import { useCallback } from 'react';

import { EOnboardRoutes } from '@skillarea/lib-frontend';
import { useLocation, useNavigate } from '@tanstack/react-router';

const ONBOARD_MODAL_HASH_ROUTES = [
  EOnboardRoutes.login,
  EOnboardRoutes.register,
  EOnboardRoutes.activate.split('/')[0],
  EOnboardRoutes.restore,
  EOnboardRoutes.change.split('/')[0],
] as const;

export function getOnboardHashRoute(hash: string): string {
  return hash.split('/')[0].replace('#', '').toLowerCase();
}

export function isOnboardModalHash(hash: string): boolean {
  if (!hash) return false;

  const currentHashRoute = getOnboardHashRoute(hash);
  return ONBOARD_MODAL_HASH_ROUTES.some((route) => route === currentHashRoute);
}

export const useOnboardModal = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const openLoginModal = useCallback(() => {
    void navigate({ to: location.pathname, hash: EOnboardRoutes.login });
  }, [location.pathname, navigate]);

  const openRegisterModal = useCallback(() => {
    void navigate({ to: location.pathname, hash: EOnboardRoutes.register });
  }, [location.pathname, navigate]);

  return {
    openLoginModal,
    openRegisterModal,
  };
};
